import * as React from 'react';
import MoreVert from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem, Link, Divider } from '@mui/material';
import { HeaderMenuProps } from './header-menu';

export function HeaderMenuSmall(props: HeaderMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = () => {
    setAnchorEl(null);
    if (props.onLoading) {
      props.onLoading(true);
    }
  };

  if (!props.links || !props.links.length) {
    return <></>;
  }

  return (
    <>
      <Box sx={props.sx}>
        <IconButton id="more-button-small" aria-label="more" color="inherit" onClick={handleClick}>
          <MoreVert />
        </IconButton>
        <Menu
          id="header-menu-small"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'more-button'
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          {props.links &&
            props.links.map((link, index) =>
              link.separator ? (
                <Divider key={link.id} />
              ) : (
                <MenuItem key={link.id} component={Link} href={link.path} onClick={handleMenuClick}>
                  {link.text}
                </MenuItem>
              )
            )}
        </Menu>
      </Box>
    </>
  );
}
